<template>
  <b-card
    title="مدیریت رژیم ها"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="col-md-2 pl-1 d-flex align-items-end">
              <b-button
                class="mb-1"
                variant="primary"
                :to="{ name: 'adddiet'}"
              >
                جدید
              </b-button>
            </div>
            <div class="col-md-10 d-flex align-items-end justify-content-end">
              <b-col md="3">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    type="text"
                    class="d-inline-block"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'updatediet', params: { id: data.value }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(DietMethod)="data">
            {{ enums('DietMethod', 'value', data.value, 'text') }}
          </template>

          <template #cell(DietType)="data">
            {{ enums('DietType', 'value', data.value, 'text') }}
          </template>

          <template #cell(ActivationType)="data">
            <b-badge
              :variant="enums('ActivationType', 'value', data.value, 'badge')"
            >
              {{ enums('ActivationType', 'value', data.value, 'text') }}
            </b-badge>
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link :to="{ name: 'updatediet', params: { id: data.item.Id }}">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>

              <feather-icon

                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>
  </b-card>
</template>

<script>

export default {
  name: 'Diet',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },

        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'DietMethod',
          label: 'متد',
        },
        {
          key: 'DietType',
          label: 'نوع',
        },
        {
          key: 'ActivationType',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.diet.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    remove(id) {
      this.removeRow(this.$api.diet.remove, 'Id', id)
    },
  },
}
</script>
